<template>
  <div style="display: flex">
      <div class="left-div">
        <el-button @click="$router.back()" size="mini" type="danger" style="margin-bottom: 10px" icon="el-icon-back"></el-button>
        <div style="color:#606266;margin-left: 30%">
          <div v-for="(parent,index) in leftMenu" :key="index" @click="scrollToAnchor(parent.url)">
            <div style="cursor: pointer;padding: 10px 0" :style="menuId === parent.url ? 'color:#ff4d4f':''">{{parent.name}}</div>
            <div class="son-menu" v-for="(son,sonIndex) in parent.sonList" :key="`menu-son-${index}-${sonIndex}`" @click.stop="scrollToAnchor(son.url)">
              <el-tooltip class="item" effect="dark" :content="son.name" placement="left">
                 <span :style="menuId === son.url ? 'color:#ff4d4f':''" >
                  {{ son.name | truncate(6) }}
                </span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="right-div">
        <div style="text-align: center;font-weight: 600;font-size: 20px;padding-right: 360px;margin-bottom: 40px">{{userDetails.workId}}</div>
        <div ref="details" style="height: 70vh; overflow-y: scroll;padding:0 360px 50px 30px;" @scroll="handleContainerScroll">
<!--          教练信息-->
          <div :id="`coach${index+1}`" v-for="(coach, index) in userDetails.children" :key="`coach-${index}-${coach.coachName || coach.id}`"
               style="margin-bottom: 10px; padding: 10px 0;">
            <el-descriptions :column="3" :title="'账号'+indexToChinese(index)">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="姓名">
                <div style="display: flex; align-items: center;">
                    <el-image class="portrait"
                        :src="coach.portrait"
                        :preview-src-list="[coach.portrait]"
                    >
                      <div slot="error" class="image-slot" style="display: flex; justify-content: center;">
                        <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                      </div>
                    </el-image>
                  <div>
                    {{ coach.coachName | truncate(6) }}
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="工作电话">{{coach.coachPhone}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="所属校区">{{ coach.campusName | truncate(10) }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="所属部门">
                <div class="tag-custom-green">{{coach.deptName}}</div></el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="角色">
                <el-select size="mini" v-model="coach.roleList"
                           multiple collapse-tags collapse-tags-tooltip placeholder="未分配角色 !" style="width: 180px">
                  <el-option v-for="(item,roleIndex) in coach.roleList" :key="roleIndex" :label="item.roleName" :value="item.id" disabled/>
                </el-select>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div id="workDetails" style="margin-top:60px">
            <el-descriptions title="工作信息" :column="3">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="工龄">{{userDetails.workAge}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="司龄">{{userDetails.companyAge}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="3">
              <el-descriptions-item label-class-name="label" content-class-name="content" label="首次工作">{{userDetails.theFirstWorkDate}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="入职时间">{{userDetails.entryTime}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="工作地点">
                <div v-for="(item,companyIndex) in companyAddress" :key="companyIndex" >
                  <span v-if="item.dictValue == userDetails.workplace" :title="item.dictLabel">
                      {{ item.dictLabel | truncate(12) }}
                  </span>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div id="userDetails" style="margin:60px 0 70px 0">
            <el-descriptions title="个人信息" :column="3">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="身份证">{{ userDetails.identity }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="性别">
                {{ userDetails.sex == 0? '女':userDetails.sex == 1 ? '男':''}}
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="3">
              <el-descriptions-item label-class-name="label" content-class-name="content" label="生日">
                {{userDetails.birthday}} ~ {{userDetails.birthdayTypeName}}
              </el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="民族">
                <div v-for="(item,nationIndex) in nation" :key="nationIndex" >
                  <span v-if="item.dictValue == userDetails.nation">{{item.dictLabel}}</span>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="3">
              <el-descriptions-item label-class-name="label" content-class-name="content" label="个人电话">{{userDetails.personagePhone}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="邮箱">
                <span style="color:#409EFF;">{{ userDetails.mailbox }}</span>
              </el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="婚姻状况">
                <div class="tag-custom-red">{{userDetails.isMarriageName}}</div>
              </el-descriptions-item>
              </el-descriptions>
            <el-descriptions :column="1">
            <el-descriptions-item label-class-name="label" content-class-name="content" label="个人简介">
                <span :title="userDetails.individualResume"> {{ userDetails.individualResume | truncate(110) }}</span>
              </el-descriptions-item>
          </el-descriptions>
          </div>
          <div id="address"  style="margin-bottom: 60px">
            <el-descriptions title="住址信息" :column="3">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="现住区域">{{ userDetails.thisAddress | truncate(20) }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="现住地址">{{userDetails.thisDetailedAddress}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="户籍区域">{{ userDetails.registeredResidenceSite | truncate(20) }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="户籍地址">{{userDetails.registeredResidenceDetailedAddress}}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div :id="`education${index+1}`" v-for="(education, index) in userDetails.educations" :key="`edu-${index}-${education.id}`"
               style="margin-bottom: 10px; padding: 10px 0;">
            <el-descriptions :column="3" :title="'学历'+indexToChinese(index)+'、'">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small" @click="$refs.updateEducation.openDialog(userDetails)">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="院校">{{education.schoolName}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="类型">{{education.isFullTimeName}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="专业">{{education.major}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="毕业时间">{{education.graduateTime}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="学历">{{education.educationRankName}}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div id="bankCard" style="margin: 60px 0">
            <el-descriptions title="银行信息" :column="3">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small" @click="$refs.updateBank.openDialog(userDetails)">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="银行">{{ userDetails.bankName }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="卡号">{{ userDetails.bankCardNumbers }}</el-descriptions-item>
            <el-descriptions-item label-class-name="label" content-class-name="content" label="姓名">
              {{ formatDescValue(userDetails.attributionName) }}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="label" content-class-name="content" label="电话">{{ formatDescValue(userDetails.bankPhone) }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div :id="`contract${index+1}`" v-for="(contract, index) in userDetails.contracts" :key="index" style="margin-bottom: 10px; padding: 10px 0;">
            <el-descriptions :column="3" :title="'合同'+indexToChinese(index)+'、'">
              <template slot="extra">
                 <el-button type="text" style="color: red;" size="small" @click="$refs.updateContract.openDialog(userDetails)">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="主体">
                <div style="display: flex;align-items: center">
                  <div>{{contract.signContractFirstPartyName}}</div>
                  <div class="use" v-if="contract.contractNumType == 1">在用</div>
                  <div class="lose" v-if="contract.contractNumType == 2">失效</div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
            <el-descriptions>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="类型">{{contract.contractTypeName}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="开始日期">{{contract.contractStartTime}}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="结束日期">{{contract.contractEndTime}}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div id="emergencyContact" style="margin: 60px 0">
            <el-descriptions title="紧急联系人" :column="3">
              <template slot="extra">
                <el-button type="text" style="color: red" size="small" @click="$refs.emergencyContact.openDialog(userDetails)">编辑</el-button>
              </template>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="姓名">{{ userDetails.emergencyContact }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="电话">{{ userDetails.emergencyContactPhone }}</el-descriptions-item>
              <el-descriptions-item label-class-name="label" content-class-name="content" label="关系">{{ userDetails.emergencyContactRelation }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div style="height: 600px"></div>
        </div>
      </div>
    <update-bank ref="updateBank"/>
    <update-emergency-contact ref="emergencyContact"/>
    <update-contract ref="updateContract" @success="selectRosterDetails"/>
    <update-education ref="updateEducation" @success="selectRosterDetails"/>
</div>
</template>

<script>
import dateUtil from '@/utils/date.js';
import UpdateContract from "./components/UpdateContract";
import {getDictByKey} from "../../../../api/contacts/dict";
import {selectRosterDetails} from '/src/api/contacts/user';
import UpdateBank from "./components/UpdateBank";
import UpdateEducation from "./components/UpdateEducation";
import UpdateEmergencyContact from "./components/UpdateEmergencyContact";
export default {
  name: 'UserDetails',
  components:{UpdateBank,UpdateContract,UpdateEducation,UpdateEmergencyContact},
  data() {
    return {
      menuId: "coach1", // 初始高亮第一个
      leftMenu: [
        {name: "小程序账号", url: "coach1", sonList: []},
        {name: "工作信息", url: "workDetails"},
        {name: "个人信息", url: "userDetails"},
        {name: "住址信息", url: "address"},
        {name: "学历信息", url: "education1", sonList: []},
        {name: "银行信息", url: "bankCard"},
        {name: "合同信息", url: "contract1", sonList: []},
        {name: "紧急联系人", url: "emergencyContact"},
      ],
      nation:[],
      contractType:[],
      companyAddress:[],
      signContractFirstParty:[],
      userDetails: {children:[],identityId:null,educations:[],contracts:[]},
    }
  },
  created() {
    this.userDetails = JSON.parse(this.$route.query.item);
    this.selectDict();
    this.selectRosterDetails();
    if (this.userDetails.entryTime!=null){
      this.userDetails.companyAge = dateUtil.getDateDiff(this.userDetails.entryTime,new Date());
    }
    if (this.userDetails.theFirstWorkDate!=null){
      this.userDetails.workAge = dateUtil.getDateDiff(this.userDetails.theFirstWorkDate,new Date());
    }
    if (this.userDetails.coachCount === 1) {
      this.userDetails.children = [this.userDetails];
    }
    this.userDetails.children.forEach((item,index)=>{
      let coach = {name:item.coachName,url:'coach'+(index+1)};
      this.leftMenu[0].sonList.push(coach);
    })
  },
  methods: {
    selectRosterDetails(){
      this.leftMenu[4].sonList=[];
      this.leftMenu[6].sonList=[];
      console.log(this.userDetails)
      selectRosterDetails(this.userDetails.identityId).then(val=>{
        if (val.status){
          this.userDetails = { ...this.userDetails, ...val.data };
          this.userDetails.educations.forEach((item,index)=>{
            let coach = {name:item.educationRankName,url:'education'+(index+1)};
            this.leftMenu[4].sonList.push(coach);
          })
          this.userDetails.contracts.forEach((item,index)=>{
            let contract = {name:'第'+this.indexToChinese(index)+'份、',url:'contract'+(index+1)};
            this.leftMenu[6].sonList.push(contract);
          })
        }
      })
    },
    indexToChinese(index) {
      let list = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return list[index] || `${index + 1}、`;
    },
     formatDescValue(value) {
      return value == null || value === '' ? '未填写' : value;
    },
    selectDict(){
      getDictByKey("nation").then(val=>{
        if (val.status){this.nation = val.data;}
      })
      getDictByKey("workplace").then(val=>{
        if (val.status){this.companyAddress = val.data;}
      })
    },
    // 滚动事件处理（防抖优化）
    handleContainerScroll() {
      const container = this.$refs.details;
      if (!container) return;
      // 滚动容器的可视区域信息
      const containerTop = container.scrollTop; // 容器滚动距离顶部
      const containerHeight = container.clientHeight; // 容器可视高度
      const containerBottom = containerTop + containerHeight; // 容器可视区域底部
      // 获取所有教练卡片
      const cards = container.querySelectorAll(
          '#workDetails,#userDetails,#address, #education, #bankCard,[id^="coach"],[id^="education"],#emergencyContact,[id^="contract"]');
      if (cards.length === 0) return;
      // 遍历所有卡片，找到当前可视的卡片
      for (let card of cards) {
        const cardRect = card.getBoundingClientRect();
        // 转换为容器内的相对位置（避免窗口滚动影响）
        const cardTopInContainer = cardRect.top + containerTop - container.getBoundingClientRect().top;
        const cardBottomInContainer = cardTopInContainer + cardRect.height;

        // 判断条件：卡片顶部进入可视区 > 30% 或完全在可视区
        const isVisible = (
            (cardTopInContainer < containerBottom - 50) && // 卡片顶部低于容器底部（留 50px 偏移）
            (cardBottomInContainer > containerTop + 50)    // 卡片底部高于容器顶部（留 50px 偏移）
        );

        if (isVisible) {
          const currentCardId = card.id; // 获取当前可视卡片的 id（如 coach1、coach2）
          // 只有当 id 变化时才更新，避免重复赋值
          if (this.menuId !== currentCardId) {
            this.menuId = currentCardId;
          }
          break; // 找到第一个可视卡片后跳出循环（避免多个卡片同时可视时冲突）
        }
      }
    },
    // 点击菜单滚动到对应卡片
    scrollToAnchor(anchorId) {
      const container = this.$refs.details;
      const target = container.querySelector(`#${anchorId}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
  mounted() {

  },
}
</script>

<style scoped>
.left-div {
  width: 300px;
  min-width: 200px;
  font-size: 14px;
  font-weight: 550;
}

.son-menu {
  padding: 10px 0;
  text-indent: 2em;
  color: #909399;
  cursor: pointer; /* 添加鼠标指针，提示可点击 */
}
.right-div {
  width: 80%;
  min-width: 1200px;
}
.portrait{
  width: 32px; height: 32px; border-radius: 6px;margin-right: 10px
}

</style>

<style>
.label{
  height: 32px;
  line-height: 32px;
}
.content{
  height: 32px;
  line-height: 32px;

}
.el-descriptions__title{
  margin-left: -30px;
  font-size: 15px;
  font-weight: 900;
  color: black;
}
.use{
  background-color: #f0f9eb;
  color: #67C23A;
  height: 26px;
  line-height: 26px;
  margin-left: 10px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  transform: scale(0.9);
}
.tag-custom-red{
  background-color: #fef0f0;
  color: #f56c6c;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
  transform: scale(0.9);
}
.tag-custom-green{
  background-color: #f0f9eb;
  color: #67c23a;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  margin-top: 2px;
  transform: scale(0.9);
}
.lose{
  background-color: #e9e9eb;
  color: #909399;
  height: 26px;
  line-height: 26px;
  margin-left: 10px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  transform: scale(0.9);
}
</style>